import { Inject, Injectable } from "@angular/core";
import { DwOrmDataServiceToken, DwOrmDataService, DwMetaDataServiceToken, DwMetaDataService, DwConfigServiceToken, DwConfigService, DwSecurityUserService, DevwareMetaData, DwUserTypeEntity } from "@devwareapps/devware-cap";
import { Observable } from "rxjs";
import { DwUserTypePilexosEntity } from "../../../meta-data/extensions/dw-user-type-entity.model";
import { AppMetaData, FlightSchoolOrganizationEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";


@Injectable({ providedIn: 'root' })
export class PilexosHomePageRepository {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        private securityUserService: DwSecurityUserService,
    ) {
        
    }

    getUserTypes(): Observable<DwUserTypePilexosEntity[]> {
        const query = DevwareMetaData.DwUserType.CreateQuery();

        query.OrderBy(DevwareMetaData.DwUserType.UserTypeOrder);

        return this.dwOrmDataService.executeQuery<DwUserTypePilexosEntity>(query);
    }


    getFlightSchoolOrganization(flightSchoolId: number): Observable<FlightSchoolOrganizationEntity> {
        const query = AppMetaData.FlightSchoolOrganization.CreateQueryBuilder();

        query.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));

        query.addField(f => f.FlightSchoolId);

        return this.dwOrmDataService.executeQuerySingle<FlightSchoolOrganizationEntity>(query);
    }
    
}